import React, { FC, useEffect, useRef, useState } from 'react';
import { ReferencedEntry } from 'contentful';
import { SheetAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { RouteComponentProps, withRouter } from 'react-router';
import DynamicComponentLazyWrapper from 'components/DynamicComponentLazyWrapper/DynamicComponentLazyWrapper';
import { componentKey, getField } from 'utils/EntryUtil';
import { onRequestClose } from 'components/NestedRoute/NestedModals';
import { SheetHeader } from './SheetHeader/SheetHeader';

interface ISheetModuleProps extends RouteComponentProps {
  entry?: ReferencedEntry<SheetAssembly>;
  modalBaseUrl?: string;
}

const SheetModule: FC<ISheetModuleProps> = ({ entry, history, match, modalBaseUrl }) => {
  const [belowFoldItems, setBelowFoldItems] = useState<any[]>([]);
  const placeholderRef = useRef<HTMLDivElement>(null);

  const { items, customIcon } = entry?.fields ?? {};

  useEffect(() => {
    if (!items || items.length < 3) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setBelowFoldItems(items.slice(2));
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1, rootMargin: '200px' },
    );

    const placeholder = placeholderRef.current;
    if (placeholder) {
      observer.observe(placeholder);
    }

    return () => {
      if (placeholder) {
        observer.unobserve(placeholder);
      }
    };
  }, [items]);

  if (!items || items.length < 2) return null;

  const aboveTheFoldComponents = items
    .slice(0, 2)
    .map((item, index) => <DynamicComponentLazyWrapper key={componentKey(item, index)} item={item} />);

  return (
    <>
      <SheetHeader
        heading={getField(entry, 'title')}
        customIcon={customIcon}
        onCloseButtonClick={() => onRequestClose(history, match, modalBaseUrl)}
      />
      {aboveTheFoldComponents}
      <div ref={placeholderRef} style={{ minHeight: '100px' }}></div>
      {belowFoldItems.map((item, index) => (
        <DynamicComponentLazyWrapper key={componentKey(item, index)} item={item} />
      ))}
    </>
  );
};

const WithRouter = withRouter(SheetModule);
export { WithRouter as SheetModule };
